/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_None_TitleInputs */

const en_us2_draft_none_title = /** @type {(inputs: Draft_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No draft to review`)
};

const pt_br2_draft_none_title = /** @type {(inputs: Draft_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum rascunho para revisar`)
};

const es_419_draft_none_title = /** @type {(inputs: Draft_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay borrador para revisar`)
};

const pt_pt2_draft_none_title = /** @type {(inputs: Draft_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum rascunho para rever`)
};

const fr_fr2_draft_none_title = /** @type {(inputs: Draft_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun brouillon à revoir`)
};

const de_de2_draft_none_title = /** @type {(inputs: Draft_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Entwurf zum Prüfen`)
};

const it_it2_draft_none_title = /** @type {(inputs: Draft_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna bozza da rivedere`)
};

/**
* | output |
* | --- |
* | "No draft to review" |
*
* @param {Draft_None_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_none_title = /** @type {((inputs?: Draft_None_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_None_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_none_title(inputs)
	if (locale === "es-419") return es_419_draft_none_title(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_none_title(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_none_title(inputs)
	if (locale === "de-DE") return de_de2_draft_none_title(inputs)
	if (locale === "it-IT") return it_it2_draft_none_title(inputs)
	return en_us2_draft_none_title(inputs)
});
export { draft_none_title as "draft.none_title" }